import CONSTANTS from '../Constants/Constants';
import ENVIRONMENT from '../Constants/Environment';
import { 
    get_flight_offer_object_from_amadeus_data,
    get_full_flight_details_from_amadeus_data,
    get_amadeus_passenger_obj,
    return_amadeus_checkout_obj,
    return_booked_flight_order_object_from_amadeus_data,
    return_booked_flight_log_object_from_amadeus_data,
} from '../data_providers/amadeus';
import {
    return_duffel_checkout_object,
    return_duffel_booked_flight_order_object,
    return_duffel_booked_flight_log_object,
} from "../data_providers/duffel";

/**
 * @classdesc Object to Adapt the Flight offer data into a common format regardless of Flight Provider
 */
export const FLIGHT_DATA_ADAPTER = {
    /**
     * @desc Raw data coming in from the api
     */
    rawData: null,

    /**
     * @desc Function to construct and preprocess
     */
    construct: () => {
        // construction here
    },

    /**
     * @desc Function to deconstruct and clean up when necessary
     */
    cleanup: () => {
        // clean up here
    },

    /**
     * @desc Adapts the flights data to output a common structure regardless of API Provider
     * @param {objec} data 
     * @returns Flight Data in a common format
     */
    get_flight_offers_from_response: (res, source=CONSTANTS.duffel, setDictionary=()=>{}) => {
        let flights = [];
        if(source.toUpperCase()===CONSTANTS.duffel){
            flights = res?.data;
        }else if(source.toUpperCase()===CONSTANTS.amadeus){
            flights = (res?.result?.data || res?.data);
            setDictionary(res?.result?.dictionaries);
            
        }
        return flights;
    },

    /**
     * @desc Adapts the flights data to output a common structure regardless of API Provider
     * @param {objec} data 
     * @returns Flight Data in a common format
     */
    adapt: (data, source=CONSTANTS.duffel, providerDictionary, type="regular") => {
        let common;
        if(source.toUpperCase()===CONSTANTS.duffel){
            common = data;
        }else if(source.toUpperCase()===CONSTANTS.amadeus){
            if(type==="regular"){
                common = get_flight_offer_object_from_amadeus_data(data, providerDictionary);
            }else if(type==="full_flight"){
                common = get_full_flight_details_from_amadeus_data(data, providerDictionary);
            }
        }
        return common;
    },

    /**
     * @desc Adapts and prepares Checkout Data for API provider creating payload object with 
     *       only required object properties
     * @param {Object} data
     * @returns {Object} checkout data
     */
    prepareCheckout: async (data, data_provider=CONSTANTS?.duffel) => {
        let checkoutObj={};
        if(/*ENVIRONMENT?.data_provider*/data_provider?.toUpperCase()===CONSTANTS?.duffel){
            checkoutObj = await return_duffel_checkout_object(data);
        }else if(data_provider?.toUpperCase()===CONSTANTS?.amadeus){
            checkoutObj = await return_amadeus_checkout_obj(data);
        }
        return checkoutObj;
    },
    
    /**
     * 
     * @param {*} passenger 
     * @param {*} data_provider 
     * @returns 
     */
    adaptPassengerObj: async (passenger, data_provider=CONSTANTS?.duffel) => {
        let common = {};
        if(data_provider?.toUpperCase()===CONSTANTS?.duffel){
            common=passenger;
        }else if(data_provider?.toUpperCase()===CONSTANTS?.amadeus){
            common= await get_amadeus_passenger_obj(passenger);
        }
        return common;
    },

    /**
     * 
     */
    addPaymentIntentToCheckout: (checkout_obj, p_intent_id) => {
        if(!checkout_obj)
            return
        checkout_obj.metadata.payment_intent_id = p_intent_id;
        return checkout_obj;
    },

    /**
     * 
     * @param {*} data 
     * @returns 
     */
    addServicesToCheckout: (checkout_obj, services=[], key_prop="id") => {
        if(!checkout_obj)
            return
        if (Array.isArray(services)) {
            for(let i=0;i<services.length;i++){
                let object = checkout_obj.services.find(each=>each[key_prop]===services[i][key_prop]);
                if(object){
                    let objIndex = checkout_obj.services.findIndex(each=>each[key_prop]===services[i][key_prop]);
                    checkout_obj.services[objIndex]=services[i];
                }else{
                    checkout_obj.services.push(services[i]);
                }
            }
        } else {
            let object = checkout_obj.services.find(each=>each[key_prop]===services[key_prop]);
            if(object){
                let objIndex = checkout_obj.services.findIndex(each=>each[key_prop]===services[key_prop]);
                checkout_obj.services[objIndex]=services;
            }else{
                checkout_obj.services.push(services);
            }
        }
        
        return checkout_obj;
    },

    /**
     * 
     */
    clearCheckoutIncludedServices: (checkout_obj) => {
        if(!checkout_obj)
            return
        checkout_obj.services=[];
        return checkout_obj;
    },

    /**
     * 
     * @param {*} data 
     * @returns 
     */
    setCheckoutPaymentToInstant: (checkout_obj) => {
        if(!checkout_obj)
            return
        checkout_obj.type="instant";
        return checkout_obj;
    },

    /**
     * 
     */
    adaptPriceProps: (data, data_provider=CONSTANTS?.duffel) => {
        if(!data)
            return
        let prices;
        if(/*ENVIRONMENT.data_provider*/data_provider?.toUpperCase()===CONSTANTS.duffel){
            prices = {
                total_amount: data?.total_amount,
                total_currency: data?.total_currency,
                tax_amount: data?.tax_amount,
                tax_currency: data?.tax_currency,
                base_amount: data?.base_amount,
                base_currency: data?.base_currency,
                extras: []
            }
        }else if(data_provider?.toUpperCase()===CONSTANTS.amadeus){

        }
        return prices
    },

    /**
     * 
     * @param {*} 
     * @returns 
     */
    return_available_services: (data, data_provider=CONSTANTS?.duffel, dictionary={}) => {
        if(!data)
            return
        let services = [];
        if(/*ENVIRONMENT?.data_provider*/data_provider?.toUpperCase()===CONSTANTS?.duffel){
            services=data?.available_services;
        }else if(data_provider?.toUpperCase()===CONSTANTS?.amadeus){
            // Amadeus
        }
        return services;
    },

    /**
     * 
     * @param {Object} data 
     * @param {String} data_provider 
     * @returns 
     */
    prepareFlightCompletedOrderObject: async (data, data_provider=CONSTANTS?.duffel, dictionary={}) =>{
        if(!data)
            return

        return await return_booked_flight_order_object_props(data, data_provider, dictionary);
    },

    /**
     * 
     */
    prepareFlightBookingLogObject: async (bookingConfirmationObject, data_provider, dictionary={}) => {
        
        if(!bookingConfirmationObject)
            return

        const {
            API_PROVIDER,
            BOOKING_ID,
            TYPE,
            AIRLINE_NAME,
            AIRLINE_IATA,
            TRIP_TYPE,
            CABIN_TYPE,
            TRAVELERS,
            ORIGIN_AIRPORT_NAME,
            ORIGIN_AIRPORT_IATA,
            ORIGIN_CITY_NAME,
            DESTINATION_AIRPORT_NAME,
            DESTINATION_AIRPORT_IATA,
            DESTINATION_CITY_NAME,
            DEPARTURE_DATE,
            RETURN_DATE
        } = await return_flight_booking_log_object_props(bookingConfirmationObject, data_provider, dictionary);

        let oc_user_id = "";
        if(localStorage.getItem("agent")){
            const agent_id = localStorage.getItem("agent");
            if(agent_id || agent_id!=="undefined")
                oc_user_id = agent_id;
        }

        let __adaptedConfirmationObject = await return_booked_flight_order_object_props(bookingConfirmationObject, data_provider, dictionary);

        return {
            oc_user_id,
            apiProvider: API_PROVIDER,
            providerBookingID: BOOKING_ID,
            originPayloads: [ __adaptedConfirmationObject ],
            type: TYPE,
            airline: AIRLINE_NAME,
            ariline_code: AIRLINE_IATA,
            trip_type: TRIP_TYPE,
            cabin_type: CABIN_TYPE,
            travellers: TRAVELERS,
            takeoff_airport: ORIGIN_AIRPORT_NAME,
            takeoff_airport_code: ORIGIN_AIRPORT_IATA,
            takeoff_city: ORIGIN_CITY_NAME,
            destination_airport: DESTINATION_AIRPORT_NAME,
            destination_airport_code: DESTINATION_AIRPORT_IATA,
            destination_city: DESTINATION_CITY_NAME,
            departure_date: DEPARTURE_DATE,
            return_date: RETURN_DATE,
        }
    }

}

/**
 * 
 */
export const return_flight_booking_log_object_props = async (obj, data_provider=CONSTANTS?.duffel, dictionary={}) => {
    if(!obj){
        return;
    }

    if(data_provider?.toUpperCase()===CONSTANTS?.duffel){
        return await return_duffel_booked_flight_log_object(obj);
    }else if(data_provider?.toUpperCase()===CONSTANTS?.amadeus){
        return await return_booked_flight_log_object_from_amadeus_data(obj, dictionary);
    }else{
        return;
    }
}

/**
 * 
 */
export const return_booked_flight_order_object_props = async (obj, data_provider=CONSTANTS?.duffel, dictionary={}) => {
    if(!obj)
        return

    if(data_provider?.toUpperCase()===CONSTANTS?.duffel){
        return await return_duffel_booked_flight_order_object(obj);
    }else if(data_provider?.toUpperCase()===CONSTANTS?.amadeus){
        return await return_booked_flight_order_object_from_amadeus_data(obj, dictionary);
    }else{
        return;
    }
}


